import { render } from "./review_appeals.vue?vue&type=template&id=4de3f11c"
import script from "./review_appeals.vue?vue&type=script&lang=js"
export * from "./review_appeals.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__